import React from "react";
import { TrendingUp, Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-emerald-950 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8 border-b border-white/10">
          {/* Brand */}
          <div>
            <a href="#" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center">
                <TrendingUp className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg text-white">FORTUNE FINSERV</span>
            </a>
            <p className="text-emerald-200 text-sm mb-4">
              Your trusted partner for wealth creation, income protection, and financial
              security.
            </p>
            <div className="space-y-2">
              <a
                href="tel:+918511291116"
                className="flex items-center gap-2 text-sm text-emerald-300 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4" />
                +91 85112 91116
              </a>
              <a
                href="mailto:investments@fortunefinserv.com"
                className="flex items-center gap-2 text-sm text-emerald-300 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4" />
                investments@fortunefinserv.com
              </a>
              <div className="flex items-start gap-2 text-sm text-emerald-300">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Thrissur, Kerala, India</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a
                href="#calculator"
                className="block text-sm text-emerald-300 hover:text-white transition-colors"
              >
                SIP Calculator
              </a>
              <a
                href="#myth-buster"
                className="block text-sm text-emerald-300 hover:text-white transition-colors"
              >
                Why SIP Works
              </a>
              <a
                href="#safety-net"
                className="block text-sm text-emerald-300 hover:text-white transition-colors"
              >
                Insurance Plans
              </a>
              <a
                href="#contact"
                className="block text-sm text-emerald-300 hover:text-white transition-colors"
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <div className="space-y-2">
              <p className="text-sm text-emerald-300">Mutual Fund Investments</p>
              <p className="text-sm text-emerald-300">SIP & Lumpsum Planning</p>
              <p className="text-sm text-emerald-300">Term Life Insurance</p>
              <p className="text-sm text-emerald-300">Health Insurance</p>
              <p className="text-sm text-emerald-300">Retirement Planning</p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="pt-8" data-testid="disclaimer-section">
          <div className="bg-white/5 rounded-xl p-6">
            <h5 className="text-white font-semibold mb-3">Important Disclaimer</h5>
            <p className="text-xs text-slate-400 leading-relaxed mb-4">
              Mutual Fund investments are subject to market risks. Read all scheme related
              documents carefully before investing. Past performance is not indicative of
              future returns. The NAV of the schemes may go up or down depending upon the
              factors and forces affecting securities markets. The information contained
              herein is solely for informational purposes and is not an offer to buy or
              sell or a solicitation of an offer to buy or sell any mutual fund or other
              security.
            </p>
            <p className="text-xs text-slate-400 leading-relaxed mb-4">
              Insurance is the subject matter of the solicitation. IRDAI is not involved
              in activities like selling insurance directly or indirectly. For more
              details on risk factors, terms, conditions, and exclusions please read the
              sales brochure/policy document carefully before concluding a sale.
            </p>
            <div className="flex flex-wrap gap-4 pt-4 border-t border-white/10">
              <div className="text-xs" data-testid="arn-code">
                <span className="text-slate-500">AMFI ARN: </span>
                <span className="text-emerald-400 font-semibold">212100</span>
              </div>
              <div className="text-xs">
                <span className="text-slate-500">Registered with: </span>
                <span className="text-emerald-400">AMFI | IRDAI</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 text-center">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Fortune Finserv. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
